import * as React from 'react';
import styled from 'styled-components';
import { CalendarDay } from '../CalendarDay';
import { useCalendar } from '../Calendar.context';
import { useMonthFormat } from './use-month-format';
import { CalendarMonthHeader } from './CalendarMonthHeader';

const MyGrid = styled.div`
    /* display: grid; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    > * {
        width: 14.28%;
    }
    /* grid-template-columns: repeat(7, 48px); */
    /* justify-content: center; */
    /* margin-bottom: 10px; */
    /* width: 336px; */
`;

const Weekday = styled.div`
    text-align: center;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

export function CalendarMonth(): JSX.Element {
    const { days, displayMonth, displayYear, onSelectDate, setHoveredDate } = useCalendar();
    const { weekLabels } = useMonthFormat(displayYear, displayMonth);

    return (
        <>
            <MyGrid>
                {weekLabels.map((weekLabel, index) => (
                    <Weekday key={`${weekLabel}${index}`}>{weekLabel}</Weekday>
                ))}
            </MyGrid>
            <MyGrid>
                {days.map(day => (
                    <CalendarDay
                        day={day}
                        key={day.date.toISOString()}
                        onClick={({ date }) => onSelectDate?.(date)}
                        onHover={({ date }) => setHoveredDate?.(date)}
                        onHoverExit={() => setHoveredDate?.(undefined)}
                    >
                        {day.date.getDate()}
                    </CalendarDay>
                ))}
            </MyGrid>
        </>
    );
}
CalendarMonth.displayName = 'CalendarMonth';
CalendarMonth.Header = CalendarMonthHeader;
